import _ from 'underscore';
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ChoiceGroup } from '@bingads-webui-react/fabric-control';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { CustomDropdown } from '../custom-dropdown-component';
import { getImportSourceFilterStyle } from './style';

const ImportSourceFilterInternal = ({
  defaultImportSource,
  choiceOptions,
  dropdownWidth,
  onChange,
  onDismiss,
  focused,
  i18n,
  classes,
}) => {
  //
  const [importSource, setImportSource] = useState(defaultImportSource);

  // choice group handling
  const selectedChoice = useMemo(
    () => _.find(choiceOptions, r => r.key === importSource),
    [importSource, choiceOptions]
  );

  const onChoiceChange = useCallback((evt, option) => {
    if (option && option.key) {
      setImportSource(option.key);
    }
  }, []);

  // the string shown on dropdown title
  const dropdownTitle = selectedChoice ? selectedChoice.title : null;

  // when the X button on dropdown title is clicked
  const onDropdownClear = useCallback((isDropdownOpen) => {
    setImportSource(null);
    if (!isDropdownOpen && onChange && defaultImportSource !== null) {
      onChange(null);
    }
  }, [defaultImportSource, onChange]);

  // when dropdown list is dismissed
  const onDropdownDismiss = useCallback(() => {
    if (onChange && defaultImportSource !== importSource) {
      onChange(importSource, dropdownTitle);
    }
    if (onDismiss) {
      onDismiss(importSource, dropdownTitle);
    }
  }, [defaultImportSource, dropdownTitle, importSource, onChange, onDismiss]);

  return (
    <CustomDropdown
      title={dropdownTitle}
      placeholder={i18n.getString(_TL_('Import source'))}
      dropdownWidth={dropdownWidth}
      onClear={onDropdownClear}
      onDismiss={onDropdownDismiss}
      focused={focused}
    >
      <div className={classes.importSourceFilterDowndown}>
        <div className="dropdown-title">{i18n.getString(_TL_('Import source'))}</div>
        <ChoiceGroup
          className="dropdown-import-source-choices"
          selectedKey={selectedChoice ? selectedChoice.key : ''}
          options={choiceOptions}
          onChange={onChoiceChange}
        />
      </div>
    </CustomDropdown>
  );
};

ImportSourceFilterInternal.propTypes = {
  defaultImportSource: PropTypes.string,
  choiceOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  focused: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  dropdownWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  classes: PropTypes.shape({
    importSourceFilterDowndown: PropTypes.string,
  }).isRequired,
};

ImportSourceFilterInternal.defaultProps = {
  defaultImportSource: null,
  onChange: undefined,
  onDismiss: undefined,
  focused: false,
  dropdownWidth: 0,
};

export const ImportSourceFilter
  = withDefaultStyles(ImportSourceFilterInternal, getImportSourceFilterStyle);
